import { useTranslation } from "@luckymenu/i18n/react";
import { useCan } from "@luckymenu/staff-core";
import { buttonVariants, PageHeader } from "@luckymenu/ui-web";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { AddonList } from "../features/menu/addon-list";
import { BackToMenu } from "../features/menu/back-link";
import { BottomBar } from "../features/menu/fields";
import { PaneHint, useInPanes } from "../features/menu/panes";

export const Route = createFileRoute("/menu/addons/")({ component: Page });

function Page() {
	const inPanes = useInPanes();
	const { t } = useTranslation("menu");
	const canEdit = useCan("menu.edit");
	if (inPanes) return <PaneHint />;
	return (
		<div className="grid max-w-3xl gap-1 pb-28 md:pb-0">
			<BackToMenu />
			<PageHeader
				title={t("addons")}
				description={t("addonsHint")}
				actions={
					canEdit ? (
						<Link to="/menu/addons/new" className={buttonVariants({ className: "max-md:hidden" })}>
							<Plus data-icon="inline-start" />
							{t("addAddonGroup")}
						</Link>
					) : null
				}
			/>
			<AddonList
				title={(group) =>
					canEdit ? (
						<Link
							to="/menu/addons/$groupId"
							params={{ groupId: group.id }}
							className="outline-none hover:underline focus-visible:underline"
						>
							{group.name}
						</Link>
					) : (
						group.name
					)
				}
			/>
			{canEdit ? (
				<div className="md:hidden">
					<BottomBar>
						<Link
							to="/menu/addons/new"
							className={buttonVariants({ size: "lg", className: "w-full" })}
						>
							<Plus data-icon="inline-start" />
							{t("addAddonGroup")}
						</Link>
					</BottomBar>
				</div>
			) : null}
		</div>
	);
}
